// extracted by mini-css-extract-plugin
export var mc_embed_signup = "newsletter-signup-module--mc_embed_signup--7dd52";
export var newsletterDescription = "newsletter-signup-module--newsletter-description--9e38a";
export var newsletterHeader = "newsletter-signup-module--newsletter-header--32ebc";
export var newsletterLeft = "newsletter-signup-module--newsletter-left--10991";
export var newsletterRight = "newsletter-signup-module--newsletter-right--5b6c7";
export var newsletterSignup = "newsletter-signup-module--newsletter-signup--92689";
export var wrapper = "newsletter-signup-module--wrapper--c46f3";